import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import StarRating from 'components/common/StarRating';
import Avatar from 'components/common/Avatar';
import { Link } from 'react-router-dom';
import { setItemToStore } from 'helpers/utils';

const Article = ({ article, setArticle }) => {
 const { code, images, name, manufacturer, measuring, params, identification, quantities } = article;
 return (
  <Card className="overflow-hidden">
   <Card.Body className="p-0">
    <Flex justifyContent="center" alignItems="center" wrap="wrap">
     <Avatar size="4xl" rounded="soft" src={images[0] ?? ''} name={name} className="ms-3 d-none d-lg-block" />
     <div className="p-x1 flex-grow-1">
      <Row className="g-0">
       <Col lg={8} as={Flex} className="flex-column pe-md-x1 cursor-pointer" onClick={() => setArticle(article)}>
        <Flex justifyContent="end" alignItems="center" className="mb-2">
         <SoftBadge pill bg="primary">
          <FontAwesomeIcon icon="pen-nib" className="me-1" transform="shrink-4" />
          {measuring}
         </SoftBadge>
        </Flex>
        <Flex justifyContent="center" alignItems="center" wrap="nowrap">
         <Avatar size="3xl" src={images[0] ?? ''} name={name} className="d-block d-sm-none" />
         <div className="flex-grow-1">
          <h5 className="mb-0 fs--1 text-capitalize">{code}</h5>
          <h4 className="m-0 fs--1 fs-md-0 fs-lg-0 text-capitalize">{name.toLowerCase()}</h4>
         </div>
        </Flex>

        <p className="fs--2 fs-md--1 text-end text-md-start">{`Creado por ${manufacturer} - id ${identification}`}</p>
        <div className="flex-1 d-flex align-items-end fw-semi-bold fs--2 fs-md--1">
         <span className="me-1 text-900">{3.5}</span>
         <StarRating readonly rating={3.5} />
         <span className="ms-2 text-secondary d-none d-sm-block">popularidad</span>
        </div>
       </Col>
       <Col lg={4} className="mt-2 mt-lg-0">
        <Flex justifyContent="between" className="h-100 rounded border-lg border-1 flex-lg-column p-lg-3">
         <div className="mb-lg-3 mt-auto mt-lg-0">
          <h4 className="m-0 fs-1 text-warning d-flex">
           <span className="fs-0 text-700">[{quantities.join('-')}]</span>
           {params?.saving > 0 && <del className="ms-1 fs--2 text-700">{params?.totals}</del>}
          </h4>
          <p className="mb-0 fs--2 fs-md--1 text-800">cantidad(es)</p>
         </div>
         <Flex className="mt-3 gap-2">
          <Button
           size="sm"
           variant="falcon-default"
           className="text-600 white-space-nowrap w-100"
           as={Link}
           to={'edit/' + code}
           onClick={() => setItemToStore('article', article)}
          >
           <FontAwesomeIcon icon="edit" className="text-primary d-md-none d-inline" />
           <span className="ms-1 d-none d-lg-inline">Editar</span>
          </Button>
          <Button size="sm" variant="falcon-default" className="text-600">
           <FontAwesomeIcon icon="trash-alt" className="text-danger" />
          </Button>
         </Flex>
        </Flex>
       </Col>
      </Row>
     </div>
    </Flex>
   </Card.Body>
  </Card>
 );
};

Article.propTypes = {
 article: PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  code: PropTypes.string.isRequired,
  quantities: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  manufacturer: PropTypes.string.isRequired,
  measuring: PropTypes.string.isRequired,
  identification: PropTypes.string,
  summary: PropTypes.string,
  images: PropTypes.array,
  taxes: PropTypes.array,
  params: PropTypes.object,
  references_name: PropTypes.array,
  references: PropTypes.arrayOf(
   PropTypes.shape({
    reference: PropTypes.string.isRequired,
    properties: PropTypes.arrayOf(
     PropTypes.shape({ name: PropTypes.string.isRequired, color: PropTypes.string, images: PropTypes.array })
    ).isRequired
   })
  ),
  specifications: PropTypes.arrayOf(
   PropTypes.shape({ label: PropTypes.string.isRequired, property: PropTypes.string.isRequired })
  )
 }).isRequired,
 index: PropTypes.number.isRequired,
 setArticle: PropTypes.func
};

export default Article;
